import {
  LOGIN_BEGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SOCIAL_LOGIN_BEGIN,
  SOCIAL_LOGIN_SUCCESS,
  SOCIAL_LOGIN_FAILURE,
} from "./Login.constant";

const initState = {
  normalLogin: {
    loading: false,
    token: "",
    error: "",
  },
  SSOLogin: {
    loading: false,
    data: {},
    error: "",
  },
};

const loginReducer = (state = initState, action) => {
  switch (action.type) {
    case LOGIN_BEGIN:
      return {
        ...state,
        normalLogin: {
          ...state.normalLogin,
          loading: true,
        },
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        normalLogin: {
          ...state.normalLogin,
          loading: false,
          token: action.payload,
          error: "",
        },
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        normalLogin: {
          ...state.normalLogin,
          loading: false,
          error: action.payload,
          token: "",
        },
      };
    case SOCIAL_LOGIN_BEGIN:
      return {
        ...state,
        SSOLogin: {
          ...state.SSOLogin,
          loading: true,
        },
      };
    case SOCIAL_LOGIN_SUCCESS:
      return {
        ...state,
        SSOLogin: {
          ...state.SSOLogin,
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    case SOCIAL_LOGIN_FAILURE:
      return {
        ...state,
        SSOLogin: {
          ...state.SSOLogin,
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default loginReducer;
